/*eslint-env node*/
const MainImage = {
  logo: require('./icon_application.png').default,
  title: require('./icon_ARK.png').default,
  donkey: require('./icon_donkey.png').default,
  minase: require('./icon_minaselogo.png').default,
  bg: require('./img_background.gif').default,
};

export default MainImage;

// 메인 이미지
